import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageHeader: {
    flex: "1 0 auto",
    position: "sticky",
    top: theme.heightDesktopHeader,
    background: "#fff",
    width: "100%",
    borderLeft: "1px solid #eeeeee",
    boxShadow: "5px 1px 7px 0px #00000026",
    height: theme.heightDesktopPageHeader,
    zIndex: theme.zIndex.page?.header,
    [theme.breakpoints.down("xs")]: {
      top: theme.heightMobileHeader,
      borderLeft: "none"
    },
    [theme.breakpoints.down("sm")]: {
      borderLeft: "none"
    }
  }
}));
